import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import classnames from 'classnames';

import FarePassengers from '../../checkout/FarePassengers';
import FareRestrictions from '../../checkout/FareRestrictions';
import FareSummary from './FareSummary';
import PointFare from '../../checkout/Fare';
import FareValidity from '../../fares/FareValidity';

class Fare extends PointFare {

    _renderFareDetails (props) {
        const { open, orderFare } = props;

        return (
            <div className={ classnames("fare-details also-visible-print", {"hidden": !open}) } >
                <FarePassengers orderFare={ orderFare } className="" />
                { orderFare.outwardJourney && orderFare.outwardJourney.validFrom && orderFare.outwardJourney.validTo && (
                    <Row className="margin-bottom--sm">
                        <Col xs={ 12 } sm={ 10 }>
                            <FareValidity
                                from={ orderFare.outwardJourney.validFrom }
                                to={ orderFare.outwardJourney.validTo }
                            />
                        </Col>
                    </Row>
                )}
                <ul className="list-unstyled exceptions-list text-sm text-light">
                    <FareRestrictions fare={ orderFare } useBootstrap/>
                </ul>
            </div>
        );
    }

    render () {
        return (
            <div>
                <FareSummary { ...this.props } />
                { this._renderFareDetails(this.props) }
            </div>
        );
    }

}

export default Fare;
